/* eslint-disable react/no-array-index-key */

import React, { FC,useCallback, useEffect, useState } from "react";

import guid from "@/v1/utils/guid";

import "./slot.scss";

interface SlotProps {
  arrangedResults: string[];
}

const Slot: FC<SlotProps> = ({ arrangedResults = ["4", "0", "4"] }) => {
  const [slotA, setSlotA] = useState<string[]>([]);
  const [slotB, setSlotB] = useState<string[]>([]);
  const [slotC, setSlotC] = useState<string[]>([]);
  const [containerHeight, setContainerHeight] = useState(0);
  const [offsetTop, setOffsetTop] = useState(0);

  const DEFAULT_QUANTITY_ITEMS = 9;

  const shuffle = (array: string[]) => {
    const mutableArray = [...array];
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex); // NOSONAR
      currentIndex -= 1;

      temporaryValue = array[currentIndex];
      mutableArray[currentIndex] = mutableArray[randomIndex];
      mutableArray[randomIndex] = temporaryValue;
    }

    return mutableArray;
  };

  const initShuffle = useCallback(() => {
    const words = ["0", "3", "4", "5", "7", "🍒", "🍗", "🍋", "🍔"];

    const arrayA = shuffle([...words]);
    arrayA.push(arrangedResults[0]);

    const arrayB = shuffle([...words]);
    arrayB.push(arrangedResults[1]);

    const arrayC = shuffle([...words]);
    arrayC.push(arrangedResults[2]);

    setSlotA(arrayA);
    setSlotB(arrayB);
    setSlotC(arrayC);
  }, [arrangedResults]);

  useEffect(() => {
    initShuffle();
  }, [initShuffle]);

  useEffect(() => {
    const container = document.querySelector(".ui-slot__roll-container") as HTMLElement;
    setContainerHeight(container?.offsetHeight || 0);
  }, [slotA, slotB, slotC]);

  useEffect(() => {
    if (containerHeight) {
      setOffsetTop(containerHeight * (slotA.length - 1 || DEFAULT_QUANTITY_ITEMS));
    }
  }, [containerHeight, slotA]);

  return (
    <div className="ui-slot">
      <div className="ui-slot__mask">
        <div className="ui-slot__roll-container">
          <div
            className="ui-slot__roll"
            style={{ height: containerHeight, transform: `translateY(-${offsetTop}px)` }}
          >
            {slotA.map((word, key) => (
              <span key={`${guid()}-${word}-${key}`}>{word}</span>
            ))}
          </div>
        </div>
        <div className="ui-slot__roll-container">
          <div
            className="ui-slot__roll"
            style={{ height: containerHeight, transform: `translateY(-${offsetTop}px)` }}
          >
            {slotB.map((word, key) => (
              <span key={`${guid()}-${word}-${key}`}>{word}</span>
            ))}
          </div>
        </div>
        <div className="ui-slot__roll-container">
          <div
            className="ui-slot__roll"
            style={{ height: containerHeight, transform: `translateY(-${offsetTop}px)` }}
          >
            {slotC.map((word, key) => (
              <span key={`${guid()}-${word}-${key}`}>{word}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slot;
